/**
 * Application-wide constants.
 * Centralises all magic numbers so changes happen in one place.
 */

/** Timing (ms) */
export const CAROUSEL_INTERVAL_MS    = 3500;
export const CAROUSEL_PAUSE_RESET_MS = 5000;
export const HERO_INTERVAL_MS        = 6000;
export const HERO_TRANSITION_MS      = 1000;

/** Layout */
export const PHOTO_GRID_COLS         = "1.6fr 1fr"; // main + thumbnails
export const PHOTOS_PREVIEW_COUNT    = 2;            // thumbnails shown beside main
export const SIMILAR_PROPERTIES_MAX  = 4;
export const FEATURED_MAX            = 6;

/** Carousel clone factor — 3 copies to enable infinite scroll */
export const CAROUSEL_CLONE_FACTOR   = 3;

/** Currency conversion rates (approximate, update periodically) */
export const THB_TO_EUR = 0.026;
export const THB_TO_AED = 0.107;
export const EUR_TO_AED = 4.02;

/** Touch swipe threshold (px) */
export const SWIPE_THRESHOLD_PX = 50;

/** Intersection Observer reveal */
export const REVEAL_THRESHOLD   = 0.1;
export const REVEAL_ROOT_MARGIN = "0px 0px -60px 0px";

/** Contact info — single source of truth */
export const PHONE_RAW     = "+971582165377";
export const PHONE_DISPLAY = "+971 58 216 53 77";
export const EMAIL         = "info@pronet-realestate.com";
export const WA_URL        = "https://wa.me/+971582165377";
export const TG_URL        = "https://t.me/pronetrealestate";
export const IG_URL        = "https://www.instagram.com/pronet_real_estate/";
export const SITE_URL      = "https://pronet-realestate.com";
